// -- Auth pages --
export const loginPage = () => import('@pages/Login');
export const registerPage = () => import('@pages/Register');
export const resetPasswordPage = () =>
  import('@pages/ResetPassword/ResetPasswordPage');
export const setPasswordPage = () => import('@pages/SetPassword');

// -- Public pages --
export const maintenancePage = () => import('@pages/Maintenance');
export const notFoundPage = () => import('@pages/NotFound');
export const paymentFailedPage = () => import('@pages/Payment');
export const shopifyInstallationPage = () =>
  import('@pages/ShopifyInstallation');
export const staticTextPage = () => import('@pages/StaticText');
export const teamInvitationConfirmPage = () =>
  import('@pages/TeamInvitationConfirm');
export const projectSharedPreviewPage = () =>
  import('@pages/ProjectSharedPreview');
export const designSharedPreviewPage = () =>
  import('@pages/designSharing/DesignSharedPreview');

// -- Dashboard section pages --
export const templatesWrapperPage = () =>
  import('@pages/Templates/TemplatesWrapper/TemplatesWrapper');
export const templatesPage = () => import('@pages/Templates');
export const industryTemplatesPage = () =>
  import('@pages/Templates/IndustryTemplates');
export const recentPage = () => import('@pages/Recent');
export const starredPage = () => import('@pages/Starred');

// -- Section layouts (keep internal Routes) --
export const userView = () => import('@layouts/UserView');
export const adminView = () => import('@layouts/AdminView');
export const teamView = () => import('@layouts/TeamView/TeamView');
export const teamPage = () => import('@pages/Team');
export const projectPage = () => import('@pages/project/ProjectPage');

// -- Onboarding --
export const onboardingPage = () => import('@pages/Onboarding');

// -- Dashboard layout --
export const dashboardLayout = () => import('@layouts/Dashboard');
